import { render, staticRenderFns } from "./TeacherMenu.vue?vue&type=template&id=c3c6c3ac"
import script from "./TeacherMenu.vue?vue&type=script&lang=js"
export * from "./TeacherMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports